import ReactApexChart from "react-apexcharts";

const COLORS = ["#5DCAA5", "#AFA9EC", "#378ADD", "#F0997B", "#FAC775", "#E24B4A"];

const CHART_TYPE_MAP = {
  STACKED_COLUMN: { type: "bar", stacked: true },
  COLUMN: { type: "bar", stacked: false },
  BAR: { type: "bar", stacked: false, horizontal: true },
  LINE: { type: "line", stacked: false },
  AREA: { type: "area", stacked: false },
  PIE: { type: "pie", stacked: false },
  DONUT: { type: "donut", stacked: false },
};

function sortBarDataAscending(categories, series) {
  // Build index array sorted by first series values ascending
  const indices = categories.map((_, i) => i).sort(
    (a, b) => series[0].data[a] - series[0].data[b]
  );

  const sortedCategories = indices.map(i => categories[i]);
  const sortedSeries = series.map(s => ({
    ...s,
    data: indices.map(i => s.data[i]),
  }));

  return { sortedCategories, sortedSeries };
}

export default function ChartResponse({ data }) {
  if (!data) return null;

  let { categories, series, x_axis_label, y_axis_label, chart_type, show_legend } = data;

  const { type, stacked, horizontal } = CHART_TYPE_MAP[chart_type] || { type: "bar", stacked: false };

  const isHorizontal = !!horizontal || categories?.length > 6;

  // Sort ascending for BAR charts only
  if (chart_type === "BAR" && categories && series?.length > 0) {
    const { sortedCategories, sortedSeries } = sortBarDataAscending(categories, series);
    categories = sortedCategories;
    series = sortedSeries;
  }

  const chartHeight = isHorizontal ? categories.length * 36 : 320;

  const options = {
    chart: {
      type,
      stacked,
      toolbar: { show: false },
    },
    colors: COLORS,
    xaxis: {
      categories,
      title: { text: x_axis_label, style: { color: "#888", fontSize: "12px" } },
    },
    yaxis: {
      title: { text: y_axis_label, style: { color: "#888", fontSize: "12px" } },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "50%",
        horizontal: isHorizontal,
      },
    },
    legend: { show: show_legend, position: "bottom" },
    dataLabels: { enabled: false },
    grid: { borderColor: "rgba(0,0,0,0.06)" },
  };

  return (
    <div className="mt-2 w-full">
      <ReactApexChart
        type={type}
        series={series}
        options={options}
        height={chartHeight}
      />
    </div>
  );
}